import parsePhoneNumberFromString, { PhoneNumber } from 'libphonenumber-js';

type DebouncedFunction<T extends (...args: any[]) => any> = (...args: Parameters<T>) => void;

export const debounce = <T extends (...args: any[]) => any>(func: T, delay: number): DebouncedFunction<T> => {
  let timeoutId: ReturnType<typeof setTimeout>;

  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

export const openLinkNewTab = (url: string) => {
  window.open(url, '_system', 'noopener noreferrer');
};

export const ArrayUniqueByKey = (data: any[], key: string) => [
  ...new Map(data.map(item => [item[key], item])).values(),
];

export const pluck = (arr, key) => arr.map(i => i[key]);
export const compareWithId = (object1, object2) => object1 === object2;

export const getPhoneNumberObject: (phoneNumber: string) => PhoneNumber = phoneNumber => {
  if (phoneNumber.substring(0, 1) !== '+') {
    phoneNumber = '+' + phoneNumber;
  }
  const phoneNumberObject = parsePhoneNumberFromString(phoneNumber);
  if (phoneNumberObject) {
    return phoneNumberObject;
  }
  return undefined;
};

export const compareVersions = (version1: string, version2: string) => {
  // Split the version strings into components
  const components1 = version1.split('.');
  const components2 = version2.split('.');

  // Find the maximum length among all components
  const maxLength = Math.max(components1.length, components2.length);

  // Pad each component with leading zeros based on the maximum length
  const paddedComponents1 = components1.map(component => component.padStart(maxLength, '0'));
  const paddedComponents2 = components2.map(component => component.padStart(maxLength, '0'));

  const joinPaddedComponents1 = paddedComponents1.join('.');
  const joinPpaddedComponents2 = paddedComponents2.join('.');

  return joinPaddedComponents1 < joinPpaddedComponents2;
};

export const encodeQueryParam: (data: any) => string = (data: any) =>
  encodeURIComponent(
    JSON.stringify(data)
      .split('')
      .map(c => c.charCodeAt(0).toString(16).padStart(2, '0'))
      .join(''),
  );

export const decodeQueryParam: (encodedData: string) => any = (encodedData: string) =>
  JSON.parse(
    decodeURIComponent(encodedData)
      .match(/.{1,2}/g)
      .map(hex => String.fromCharCode(parseInt(hex, 16)))
      .join(''),
  );

export const transformWeight: (weight?: number) => string = (weight?: number) => {
  if (!weight || weight <= 0) {
    return '';
  }

  const formatWeight = (num: number) => {
    const formatted = new Intl.NumberFormat('id-ID', {
      maximumFractionDigits: 2,
    }).format(num);

    return formatted;
  };

  // if weight less than 1000, add 'gr'
  if (weight < 1000) {
    return formatWeight(weight) + ' gr';
  }

  // if weight greater than 1000, add 'kg'
  if (weight > 1000) {
    return formatWeight(weight / 1000) + ' Kg';
  }

  return '';
};
